import axios from "axios";
let source = null;

export default {
  getProviders(zipCode) {
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();

    return new Promise((resolve) => {
      axios({
        method: "get",
        url: `${process.env.GEO_SERVICE_PUBLIC_PATH}/region/${zipCode}/energy-providers`
      })
        .then(response => resolve(response.data))
        .catch(error => {
          console.error(error.response);
          resolve(null);
        });
    });
  },
  getHotlossProviders() {
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();
    const url = `${process.env.GEO_SERVICE_PUBLIC_PATH}/providers/hotloss`;

    return new Promise((resolve) => {
      axios({
        method: "get",
        url: url
      })
        .then(response => resolve(response.data))
        .catch(error => {
          console.error(error.response);
          resolve(null);
        });
    });
  },
  getRegion(zipCode) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.GEO_SERVICE_PUBLIC_PATH}/region/${zipCode}`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response));
    });
  },
  cancelRequest() {
    if (source) {
      source.cancel('The request has been cancelled by the user.');
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/geoService.js